const channels = require.context('.', true, /_channel\.(js|coffee)$/)
channels.keys().forEach(channels)
